function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "#00A1E0",
  fillRule: "evenodd",
  d: "M8.5 16.056A7.556 7.556 0 1116.056 8.5 7.556 7.556 0 018.5 16.056zm.708-6.297c0 .174-.14.315-.314.315h-.709a.315.315 0 01-.315-.315c0-2.092 1.771-1.894 1.771-3.463 0-.521-.592-.944-1.2-.944s-1.21.423-1.21.944c-.002.18.026.358.082.528a.313.313 0 01-.296.417h-.64a.316.316 0 01-.305-.23 2.635 2.635 0 01-.09-.715c0-1.217 1.127-2.203 2.518-2.203 1.391 0 2.519.986 2.519 2.203 0 2.02-1.81 1.942-1.81 3.463zM8.5 11.02a.944.944 0 11-.944.944c0-.522.422-.944.944-.944z"
});

var SvgSalesforceSupport = function SvgSalesforceSupport(props) {
  return React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17"
  }, props), _ref);
};

export default SvgSalesforceSupport;